import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=1beb3b1c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Download.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Download.vue
// module id = 2393
// module chunks = 1